import Vue from 'vue'
import {
    Table,
    Row,
    Col,
    Aside,
    Button,
    Message,
    MessageBox,
    Header,
    Input,
    Form,
    FormItem,
    Menu,
    Submenu,
    MenuItem,
    Breadcrumb,
    BreadcrumbItem,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Container,
    Main,
    TableColumn,
    Pagination,
    Dialog,
    Tree,
    Avatar,
    Select,
    Option,
    Cascader,
    Switch,
    Image,
    Tag,
    DatePicker,
    Card,
    Descriptions,
    DescriptionsItem,
    Upload,
    RadioGroup,
    Radio,
    Autocomplete,
    Tabs,
    TabPane,
    Popover
} from 'element-ui'

const components = {
    Popover,
    TabPane,
    Tabs,
    Autocomplete,
    Radio,
    RadioGroup,
    DescriptionsItem,
    Descriptions,
    Card,
    DatePicker,
    Tag,
    Image,
    Switch,
    Cascader,
    Option,
    Select,
    Avatar,
    Tree,
    Dialog,
    Pagination,
    Table,
    TableColumn,
    Main,
    Container,
    Row,
    Col,
    Aside,
    Input,
    Button,
    Menu,
    Form,
    FormItem,
    Header,
    Submenu,
    MenuItem,
    Breadcrumb,
    BreadcrumbItem,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Upload
}

Object.entries(components).forEach(([name, component]) => {
    Vue.use(component)
})

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
